import {COUPON_ERROR, GET_COUPON, PATCH_COUPON, POST_COUPON, DELETE_COUPON, COUPON_LOADING} from 'app/types'
let momentZone=require('moment-timezone')
const initialState = {
    coupons:[],
    loading:true
}

export default function couponReducer (state = initialState, action) {

    switch(action.type){
        case COUPON_LOADING:
            return {
                ...state ,
                loading : true,
                error : null
            }
        case GET_COUPON:
            return {
                ...state,
                coupons : action.payload ,
                loading : false
            }
        case COUPON_ERROR :
            return {
                ...state,
                loading: false ,
                error : action.payload
            }
        case POST_COUPON :
            return {
                ...state ,
                loading: false ,
                coupons: [...state.coupons].concat( {...action.payload ,
                    startDate : momentZone.tz(action.payload.startDate , "Africa/Algiers").format('L'),
                    startHour: momentZone.tz(action.payload.startDate , "Africa/Algiers").format('LT'),
                    endDate : momentZone.tz(action.payload.endDate , "Africa/Algiers").format('L'),
                    endHour: momentZone.tz(action.payload.endDate , "Africa/Algiers").format('LT')} )
            }
        case PATCH_COUPON :
            const indexCouponModified = state.coupons.findIndex(coupon => coupon._id ==action.payload.updatedCouponId);
            const newModifedCoupons =[...state.coupons];
            newModifedCoupons[indexCouponModified]=action.payload.updatedCoupon;
            return {
                ...state ,
                loading: false ,
                coupons: newModifedCoupons
            }
        case DELETE_COUPON :
            const CouponsNotDeleted = state.coupons.filter( coupons => coupons._id !==action.payload);
            return {
                ...state ,
                coupons: CouponsNotDeleted,
                loading : false ,
                error : null
            }
        default: return state
    }

}